import type { ReactNode } from 'react';
import { css } from '../../../../styled-system/css';

type ClauseProps = {
  title: string;
  children: ReactNode;
};

export function Clause({ title, children }: ClauseProps) {
  return (
    <div className={css({ display: 'flex', flexDirection: 'column', gap: '{spacing.20}' })}>
      <h2 className={css({ textStyle: 'headding.m' })}>{title}</h2>
      {children}
    </div>
  );
}
